
import TextBlock from '~/components/ui/TextBlock.vue'
export default {
  props: {
    aboutTrakken: {
      type: Array,
      required: true
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'transparent'
    },
    highlightColor: {
      type: String,
      required: false,
      default: '#fff'
    }
  },
  components: {
    TextBlock
  },
  computed: {
    containerStyle() {
      return {
        '--background-color': this.backgroundColor,
        '--color': this.backgroundColor == 'transparent' ? '' : '#fff'
      }
    }
  }
}
